import { useEffect, useRef, useState } from 'react';
import { useServicesVideo } from './useServicesVideo';

const AboutPoster = ({ hidden = false }) => (
  <picture className={`about-reference-picture${hidden ? ' about-poster-hidden' : ''}`} data-testid="about-motif-picture">
    <source media="(max-width: 760px)" srcSet="/media/about-poster-mobile.webp" width="960" height="673" />
    <img src="/media/about-poster-desktop.webp" alt="Blaue Reinigungshandschuhe auf einem blauen Mikrofasertuch, dahinter eine blaue Sprühflasche in einem hellen, modernen Büro" loading="lazy" decoding="async" width="2000" height="1143" data-testid="about-motif-image" />
  </picture>
);

const AboutPlayback = () => {
  const { videoRef, source, poster, canRun, hasPlayed, playing, onPlaying, onPause, onError } = useServicesVideo({
    assetName: 'betaris-about', posterName: 'about-poster',
  });

  useEffect(() => {
    const video = videoRef.current;
    return () => {
      if (!video) return;
      video.pause(); video.removeAttribute('src'); video.load();
    };
  }, [videoRef, source]);

  return <>
    <video key={source || 'about-still'} ref={videoRef} data-testid="about-video" className="about-reference-video"
      src={source || undefined} poster={poster} autoPlay={canRun} muted loop playsInline preload="none"
      onPlaying={onPlaying} onPause={onPause} onError={onError} tabIndex={-1}
      disablePictureInPicture disableRemotePlayback controlsList="nodownload nofullscreen noremoteplayback" aria-hidden="true" />
    <AboutPoster hidden={hasPlayed && canRun} />
    <span className="sr-only" data-testid="about-video-status">{playing ? 'Die Handschuh-Animation läuft stumm in Endlosschleife.' : 'Unbewegtes Motiv mit blauen Reinigungshandschuhen.'}</span>
  </>;
};

export const AboutMedia = () => {
  const mediaRef = useRef(null);
  const [loadVideo, setLoadVideo] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setLoadVideo(true);
      observer.disconnect();
    }, { rootMargin: '240px 0px' });
    if (mediaRef.current) observer.observe(mediaRef.current);
    return () => observer.disconnect();
  }, []);

  return <div ref={mediaRef} className="about-reference-media" data-testid="about-media">
    {loadVideo ? <AboutPlayback /> : <AboutPoster />}
  </div>;
};